var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full border-t-8 border-orange-400"},[_c('div',{staticClass:"w-full p-10 mx-auto md:w-3/4"},[_c('p',{staticClass:"text-center"},[_vm._v("© "+_vm._s(_vm.year)+" Bobbe Harris. All rights reserved.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }